<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="showSearch">搜索</Button>
		</div>
		<div>
			<Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
				<p slot="header" style="color:#0066FF;text-align:center">
					<span>搜索</span>
				</p>
				<div style="padding-left: 20px;">
					<CheckboxGroup v-model="selectedConditions" class="check_group">
						<div>
							<Checkbox label="num">
								<span>设备编号</span>
							</Checkbox>
							<Input v-model="condition.num" placeholder="" />
						</div>
						<div>
							<Checkbox label="type">
								<span>通讯类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.type">
								<Option :value="1" :key="1">NB</Option>
								<Option :value="2" :key="2">WIFI</Option>
							</Select>

						</div>
						<div>
							<Checkbox label="gasType">
								<span>用气类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.gasType">
								<Option :value="1" :key="1">液化天然气</Option>
								<Option :value="2" :key="2">液化石油气</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="subType">
								<span>消息类型</span>
							</Checkbox>
							<Select v-model="condition.subType" placeholder="请选择命令字">
								<Option v-for="(value, key) in alarmProfile['upload']"  :value="key"
									:key="key">{{value.cn}}</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="happenTime">
								<span>时间范围</span>
							</Checkbox>
							<Tooltip transfer placement="top" :disabled="condition.happenTimeRange[0] == ''">
								<div slot="content">
									<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[0])}}</span>
									<br />
									<span style="margin-left:50%">~</span>
									<br />
									<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[1])}}</span>
								</div>
								<DatePicker v-model="condition.happenTimeRange" type="daterange" split-panels
									placeholder=""></DatePicker>
							</Tooltip>
						</div>
					</CheckboxGroup>
				</div>
				<div slot="footer">
					<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
				</div>
			</Modal>
		</div>
		<br />
		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
			</template>
		</Table>
		<br />
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "alarm_Daily_Data",
		data() {
			let that = this;
			return {
				alarmProfile: {},
				collection:{},
				rebootRecord:{},
				regularUpload:{},
				valveClose:{},
				valveOperation:{},
				data1: [],
				loading: true,
				showDrawer: false,
				selectDataHtml: '',
				selectData: {},
				searchModal: false,
				currentPage: 1,
				pageSize: 40,
				totalRows: 0,
				selectedConditions: [],
				condition: {
					id: '',
					mac: '',
					happenTimeRange: [],
					},
				requestBody: {},
				columns1: [
      			    {
						title: "姓名",
						key: "name",
						align: "center",
						width: 100,
					},
					{
						title: "电话",
						key: "telephone",
						align: "center",
						width: 200,
					},
					{
						title: "地址",
						key: "address",
						align: "center",
						width: 200,
        			},
					{
						title: "设备编号",
						key: "num",
						align: "center",
						width: 200,
					},
					{
						title: "类型",
						key: "subType",
						align: "center",
						width: 130,
					},
      			    {
						title: "内容",
						key: "content",
						align: "center",
						width: 350,
					},
					{
						title: "上传时间",
						align: "center",
						width: 200,
						render: function(h, params) {
							try {
								if (params.row.happenTime != undefined) {
									let timeStr = global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.happenTime)
									);
									return h("div", timeStr == "" ? "设备未校时" : timeStr);
								} else {
									return h(
										"div",
										global.dateFtt(
											"yyyy-MM-dd hh:mm:ss",
											new Date(params.row.receiveTime)
										)
									);
								}
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "用气类型",
						key:  "",
						align: "center",
						width: 150,
						render: function(h, params) {
							return h(
								"div",
								 params.row.gasType == 1 ? "液化天然气" : "液化石油气"
							);
						}
					},
					{
						title: "通讯方式",
						key: "",
						align: "center",
						width: 100,
						render: function(h, params) {
							return h(
								"div", 
								params.row.type == 1 ? "NB" : "WIFI"
							);
						}
					}
				],
			};
		},
		created() {
			this.getAlarmProfile()
			this.getMessage()
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			getAlarmProfile() {
				let that = this;
				that.loading = true;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getProfile",
					async: false,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.alarmProfile = result.data;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			showSearch() {
				this.searchModal = true;
			},
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							if (this.id != "") {
								this.requestBody["id"] = this.id;
							}
							if (this.num != "") {
								this.requestBody["num"] = this.num;
							}
							if (this.type.value != "") {
								this.requestBody["type"] = this.type;
							}
							if (this.gasType.value != "") {
								this.requestBody["gasType"] = this.gasType;
							}
             				 if (this.subType.value != "") {
								this.requestBody["subType"] = this.subType;
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}
							this.requestBody[selectedCondition] = value;
							break;
					}
				}
				this.loading = true;
				this.searchModal = false;
				this.currentPage = 1;
				this.getMessage();
			},
			getMessage() {
				let that = this;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/alarm/admin/message/getAlarmUploadList?currentPage=" + that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true&",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if(result.data.list.content){

						}
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.loading = false;

					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "网络不通"
						});
					}
				});
			},
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.currentPage = index;
				this.loading = true;
				this.getMessage();
			},
			convertData(data, type, enums) {
				let result = data;
				if (type == "Time") {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if (type == "Enum") {
					result = enums[data] == null ? data : enums[data];
				}
				return result;
			},
		},
	};
</script>
<style>
	.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 100px;
	}
	.check_group>div>div {
		width: 200px;
	}
	.ivu-date-picker {
		width: 100%;
	}
</style>